import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User } from '../_models';
import { CommonService } from './common.service';
import { EncryptionService } from './encryption.service';

@Injectable({ providedIn: 'root' })
export class UserService {
	userInfo: any = new User();
	@Output() getUserData: EventEmitter<any> = new EventEmitter();

	constructor(private http: HttpClient, private commonService: CommonService, private encryptionService: EncryptionService) {
		if (typeof window !== 'undefined' && localStorage.getItem('autherize_data') !== null) {
			// const user = JSON.parse(localStorage.getItem('auth_user') || '');
			if (!this.loggedIn()) {
				this.commonService.navigateTo('');
			}
			const user = this.encryptionService.decrypt(localStorage.getItem('autherize_data') || '');
			this.userInfo = user ? user : new User();
			this.commonService.setPermissions(this.userInfo?.permissions || {});
		}
	}

	storeUserInfo(res: any) {
		this.userInfo = {
			id: res.user._id,
			firstName: res.user?.firstName,
			lastName: res.user?.lastName,
			username: res.user?.firstName + ' ' + res.user?.lastName,
			email: res.user?.email,
			type: res.user?.type,
			mobile: res.user?.mobile,
			logo:
				res.user.profile_pic && res.user.profile_pic.length !== 0
					? res.user.profile_pic[0]
					: 'assets/images/edit-profile-pic.png',
			token: res.token,
			role: res.user?.roleId?.slug,
		};
		const permissionObj = this.setUserPermissions(res?.user?.roleId?.capabilities || []);
		this.userInfo.permissions = permissionObj;
		localStorage.setItem('auth_token', res.token);
		// localStorage.setItem('auth_user', JSON.stringify(this.userInfo));
		localStorage.setItem('autherize_data',this.encryptionService.encrypt(this.userInfo))
		// localStorage.setItem('capabilities', res.user.roleId.capabilities);
		this.getUserData.emit(this.userInfo);

		//Update the permission to command Service
		this.commonService.setPermissions(permissionObj);
	}

	getUserInfo() {
		return this.userInfo;
	}

	// getUserPermissions() {
	// 	const capabilities = localStorage.getItem('capabilities') ?? '';
	// 	return Object.fromEntries(capabilities.split(',').map(p => p.trim()).filter(Boolean).map(p => [p, true]));
	// }

	setUserPermissions(permission_data: any = []) {
		return Object.fromEntries(permission_data.map((p:any) => [p, true]));
	}

	loggedIn(): boolean {
		let isLoggedIn = false;

		if (typeof window !== 'undefined') {
			isLoggedIn = localStorage.getItem('auth_token') !== null;
		}

		return isLoggedIn;
	}

	clearUserData() {
		localStorage.removeItem('auth_token');
		// localStorage.removeItem('auth_user');
		localStorage.removeItem('autherize_data');
		// localStorage.removeItem('capabilities');
		this.userInfo = null;
	}

	updateProfile(userObj:any) {
		return this.http.put('/users/update-profile', userObj);
	}
	changePassword(userObj:any) {
		return this.http.post('/change-password', userObj);
	}
}
